//@flow

import React from 'react';
import { Button } from 'reactstrap';
import BookFlights from './BookFlights';

type Props = {
  currency: string,
  totalAmount?: number,
  flightId: string,
  returnFlightId: string | null,
  show: boolean,
  extraClass: boolean,
  bookFlights: (flight: string, returnFlightId: string | null) => void,
  sessionId: null | String,
};

function BookFlightsButton(props: Props) {
  const {
    currency,
    totalAmount,
    flightId,
    returnFlightId,
    show,
    extraClass,
    honeyguideCredit,
    sessionId,
  } = props;

  return (
    <div style={{ visibility: show ? 'visible' : 'hidden' }}>
      <div className={`flight_buy_action ${extraClass ? 'mt-2' : ''}`}>
        {totalAmount && (
          <h5 className="flight_price">
            {currency} {totalAmount.toLocaleString()}
          </h5>
        )}
        <BookFlights flightId={flightId} returnFlightId={returnFlightId} sessionId={sessionId}>
          {({ handleBook }) => {
            return (
              <Button color="yellow" onClick={handleBook}>
                BOOK FLIGHT
              </Button>
            );
          }}
        </BookFlights>
        {<p className="flight_free_message credit">{currency} {honeyguideCredit} HoneyGuide Credit</p>}
        <p className="flight_free_message">FREE Cancellation</p>
      </div>
    </div>
  );
}

BookFlightsButton.defaultProps = {
  show: true,
};

export default BookFlightsButton;



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/BookFlightsButton.js